'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { plariumPlayDownloadStarted, useDownloadFile, useGetDownloadLink } from '@/shared/modules/download';
import { useGetAppIdForMessageAfterDownloadInstaller } from '@/shared/modules/download/hooks/use-get-app-id';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { useGetBrowserDetails } from '@/shared/modules/user-agent';
import { BROWSER_NAME } from '@/shared/modules/user-agent/constants';
import { DownloadMessage } from './components/download-message';
import { Instruction } from './components/instruction';
import * as Styled from './thank-you-desktop.styled';
const LOGO_WIDTH = 140;
const LOGO_HEIGHT = 140;
/**
 * @useClient
 */
export const ThankYouDesktop = React.memo(function ThankYouDesktop() {
  const {
    images,
    strings,
    links
  } = useEdgeConfigWidget(WidgetId.ThankYouContent);
  const downloadLink = useGetDownloadLink(links);
  const download = useDownloadFile();
  const appId = useGetAppIdForMessageAfterDownloadInstaller(downloadLink);
  const {
    browserName
  } = useGetBrowserDetails();
  React.useEffect(() => {
    if (browserName === undefined || !downloadLink) {
      return;
    }
    plariumPlayDownloadStarted();
    if (browserName !== BROWSER_NAME.MICROSOFT_EDGE) {
      download(downloadLink);
    } else {
      window.open(downloadLink, '_self');
    }
  }, [browserName, downloadLink, download]);
  return <Styled.Wrapper $background={images.background.src}>
      <Styled.Header>
        <Styled.Logo src={images.logo.src} alt="Plarium logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} />
        <Styled.Title>{strings.title}</Styled.Title>
        <Styled.Description>{strings.description}</Styled.Description>
        <Styled.AdditionalText html={strings.additionalText} />
      </Styled.Header>
      <Instruction />
      {appId && <DownloadMessage appId={appId} />}
    </Styled.Wrapper>;
});